import { api } from '../api';
import { Institution } from '../../entities/Institution';

/**
 * A resposta perdeu o `patientsLists` na tarefa 0.13 do roadmap B2G. Ele vinha de
 * um `patients[]` que o back **aceitava e descartava**: a tela dizia ter vinculado
 * paciente e nada era vinculado. Vincular paciente a instituição passou a ser
 * `PUT /patients/{id}/institution` (0.15).
 */
export interface CreateInstitutionResponse {
  institution: Institution;
}

export const createInstitution = async (
  institutitonRequest: Institution,
): Promise<CreateInstitutionResponse> => {
  const { data } = await api.post('/institutions', institutitonRequest);

  return data;
};
